// extracted by mini-css-extract-plugin
export default {"edit":"ItemStarsEdit_edit__ZnvfZ","editLevel":"ItemStarsEdit_editLevel__VvpsU","darkerText":"ItemStarsEdit_darkerText__PnBRE"};